import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'asia-3',
  defaultLocale: 'th-TH',
  availableLocales: ['en-TH', 'th-TH'],
  timedBanners: {
    privatePolicyBanner: {
      cookieConsent: {
        displayDates: {
          startDate: '2024-01-19T00:00:00.000Z',
        },
        type: 'CookieConsent',
      },
      privatePolicy: {
        displayDates: {
          startDate: '2024-01-19T00:00:00.000Z',
          endDate: '2024-02-20T23:59:59.000Z',
        },
        type: 'PrivacyPolicy',
      },
    },
    candidateOnboardingBanner: {
      displayDates: {
        startDate: '2024-01-19T00:00:00.000Z',
        endDate: '2024-02-20T23:59:59.000Z',
      },
      externalHelpURL: {
        en: 'https://help.th.jobsdb.com/s/article/Understanding-The-Changes-On-The-New-Jobsdb-By-SEEK-TH?language=en_US',
        th: 'https://help.th.jobsdb.com/th/s/article/Understanding-The-Changes-On-The-New-Jobsdb-By-SEEK-TH?language=th',
      },
    },
  },
  zoneFeatures: {
    QUICK_SEARCH_ENABLED: true,
    NORTHSTAR_SEO_TAGS: true,
    NUDGE_ENABLED: false,
    SHOW_HOMEPAGE_BANNER: true,
    HOMEPAGE_BANNER_TYPE: 'GENERIC_ASIA_BANNER',
    SEARCH_PAGE_SIZE: 30,
    SPLITVIEW_ENABLED: true,
    PDPA_CONSENT_REQUIRED: true,
    SHOW_FLOATING_SAVE_SEARCH: false,
    SHOULD_OPEN_APPLY_IN_NEW_TAB: true,
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    SHOW_STICKY_APPLY_ON_DESKTOP: true,
    SERP_KEYWORD_TEXTFIELD: true,
    LMIS_ENABLED: true,
    SALARY_TRANSPARENCY_ENABLED: false,
    COMPANY_PROFILE_ON_JDV: true,
    BEHAVIOURAL_CUES_ENABLED: false,
    REDUCED_DUPLICATED_APPLY_FEATURE: false,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_dgOh8Yali0X6D5LPpX679mjkuFnVPBnB'
    : 'key_test_baKe5Wbdl33XD3LQi6260idbvzfPPAfV',
} as AppConfig;
